import React from 'react';
import { EMPTY } from 'rxjs';
import { defineMessages, FormattedMessage } from 'react-intl';

import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  printingEndOfDayFormSuccessTitle: {
    description: 'printEpics.printingEndOfDayFormSuccessTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {End of Day Form} one {End of Day Form} other {End of Day Forms}}...',
    id: 'RRk7Mx',
  },
  printingEndOfDayFormSuccessContent: {
    description: 'printEpics.printingEndOfDayFormSuccessContent',
    defaultMessage: '{docCount, plural,=0 {End of Day Form} one {End of Day Form} other {End of Day Forms}} sent to {printerName}.',
    id: 'v7tONq',
  },
  downloadEndOfDayFormStartedTitle: {
    description: 'printEpics.downloadEndOfDayFormStartedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {End of Day Form} one {End of Day Form} other {End of Day Forms}}...',
    id: 'uEtj26',
  },
  downloadEndOfDayFormStartedContent: {
    description: 'printEpics.downloadEndOfDayFormStartedContent',
    defaultMessage: '{docCount, plural,=0 {End of Day Form} one {End of Day Form} other {End of Day Forms}} Download Started.',
    id: 'c75Qiw',
  },
  downloadEndOfDayFormCompletedTitle: {
    description: 'printEpics.downloadEndOfDayFormCompletedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {End of Day Form} one {End of Day Form} other {End of Day Forms}}...',
    id: 'U9j7ES',
  },
  downloadEndOfDayFormCompletedContent: {
    description: 'printEpics.downloadEndOfDayFormCompletedContent',
    defaultMessage: '{docCount, plural,=0 {End of Day Form} one {End of Day Form} other {End of Day Forms}} Download Completed.',
    id: 'IxgYI6',
  },
});

export const endOfDayForm = {
  id: DocumentType.EndOfDayForm.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadEndOfDayFormStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadEndOfDayFormStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadEndOfDayFormCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadEndOfDayFormCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingEndOfDayFormSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingEndOfDayFormSuccessContent} values={{ docCount, printerName }} />,
  }),

  getPrintedSuccessObservable: () => {
    return EMPTY;
  },
};
